import { userProfileConstants } from '../../_constants';
import { userProfileService } from '../../_services';

export const demographicDataAction = {
    getDemographicDataHandler
};

function getDemographicDataHandler() {
    return dispatch => {
        dispatch(request());
        userProfileService.getDemographicDataHandler()
            .then(
                getDemographicData => {
                    dispatch(success(getDemographicData));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userProfileConstants.REQUEST_DEMOGRAPHIC_DATA} }
    function success(getDemographicData) { return { type: userProfileConstants.RECEIVE_DEMOGRAPHIC_DATA, getDemographicData } }
    function failure(error) { return { type: userProfileConstants.DEMOGRAPHIC_DATA_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/UserProfile/demographicData.action.js